module.exports = __webpack_public_path__ + "static/media/2.16d39d32.jpg";